<template>
  <div class="fullpage-container">
    <div class="menu">
      <div class="menu-left">
        <img class="logo" src="@/assets/logo.png" alt="" @click="moveto(0)">
      </div>
      <div class="menu-right">
        <tasty-burger-button
        id="menuBtn"
        :type="type"
        :active="isActive"
        :size="size"
        :color="color"
        :active-color="activeColor"
        v-on:toggle="onToggle"/>
      </div>
    </div>
    <div class="pagenation">
      <div @click="moveto(0)" :class="[currentPage !== 0 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(1)" :class="[currentPage !== 1 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(2)" :class="[currentPage !== 2 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(3)" :class="[currentPage !== 3 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(4)" :class="[currentPage !== 4 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(5)" :class="[currentPage !== 5 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(6)" :class="[currentPage !== 6 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(7)" :class="[currentPage !== 7 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(8)" :class="[currentPage !== 8 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(9)" :class="[currentPage !== 9 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(10)" :class="[currentPage !== 10 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(11)" :class="[currentPage !== 11 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(12)" :class="[currentPage !== 12 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(13)" :class="[currentPage !== 13 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(14)" :class="[currentPage !== 14 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(15)" :class="[currentPage !== 15 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(16)" :class="[currentPage !== 16 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <!-- <div @click="moveto(17)" :class="[currentPage !== 17 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div> -->
    </div>
    <div :class="[menuFlag === 0 ? 'menu-off' : 'menu-on']">
      <div class="menu-div">
        <span class="menu-title">
          &nbsp;
        </span>
      </div>
      <div class="menu-div">
        <span class="menu-title" @click="moveto(0, 'category')">
          HOME
        </span>
      </div>
      <div class="menu-div">
        <span class="menu-title" @click="moveto(2, 'category')">
          사용후기
        </span>
      </div>
      <div class="menu-div">
        <span class="menu-title" @click="moveto(8, 'category')">
          인공지능세리
        </span>
      </div>
      <div class="menu-div">
        <span class="menu-title" @click="moveto(13, 'category')">
          서비스문의
        </span>
      </div>
      <div class="menu-div">
        <span class="menu-title" @click="moveto(16, 'category')">
          이벤트
        </span>
      </div>
      <div class="menu-bot">
        <button class="promo-btn" @click="openJoin">
          무료체험<br>3만원 무료충전
        </button>
        <!-- <button class="kakao-btn" @click="clickKakao">
          <img src="@/assets/mobile/icon_kakao.png" alt="">
          카톡상담
        </button> -->
        <div id="create-channel-chat-button"></div>
        <div class="seryService">
          <img class="service-icon" src="@/assets/pc/icon_cs.png" alt="">
          <img class="service-icon" src="@/assets/pc/icon_service.png" style="" alt="">
          <img class="service-icon" src="@/assets/pc/icon_google.png" alt="">
        </div>
        <div class="serService">
          <img src="@/assets/pc/naver_icon.png" class="service-icon" alt="">
          <img src="@/assets/pc/kakao_icon.png" class="service-icon" alt="">
        </div>
        <div style="width:100%; display:flex;align-items:center;justify-content: center;flex-direction:column;margin:50px 0px 0px;">
          <span class="reserved">ⓒ 2018 tonovation, All rights reserved.</span>
          <span class="reserved">토노베이션</span>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="fullpage-wp" v-fullpage="opts" ref="main">
        <div class="page-1 page">
          <img src="@/assets/mobile/main01.png" class="main01" alt="">
        </div>
        <div class="page-2 page">
          <img src="@/assets/mobile/main02.png" class="main01" alt="">
          <div class="page-2-content">
            <span style="font-size: 1.2em; color:#ffffff;line-height:35px;">
              세리서비스
            </span>
            <span style="font-size: 1.6em;font-weight:bold;color:#ffffff;line-height: 35px;">
              이용하기
            </span>
            <hr style="margin:15px 0px;border: 4px solid #ffffff;width:40%;">
            <span style="font-size: 1.1em; line-height:27px;color:#ffffff;">
              무료체험과 동시에
            </span>
            <span style="font-size: 1.1em; line-height:27px;color:#ffffff;">
              3만원 무료충전<br>
            </span>
            <button class="page-2-btn" @click="openJoin">
              무료체험하기
            </button>
          </div>
        </div>
        <div class="page-3 page" style="justify-content: flex-end;">
          <img src="@/assets/mobile/main03.png" class="main01" alt="">
        </div>
        <div class="page-4 page">
          <img src="@/assets/mobile/main04.png" class="main01" style="position:absolute;bottom:0px;" alt="">
        </div>
        <div class="page-5 page">
          <img src="@/assets/mobile/main05.png" class="main01" alt="">
        </div>
        <div class="page-6 page">
          <img src="@/assets/mobile/main06.png" class="main01" alt="">
        </div>
        <div class="page-7 page">
          <img src="@/assets/mobile/main07.png" class="main01" alt="">
        </div>
        <div class="page-8 page">
          <img src="@/assets/mobile/main08.png" class="main01" alt="">
        </div>
        <div class="page-9 page">
          <img src="@/assets/mobile/main09.png" class="main01" alt="">
        </div>
        <div class="page-10 page" style="justify-content:flex-end;">
          <img src="@/assets/mobile/main10.png" class="main01" style="width:80%;" alt="">
          <div class="page-10-content">
            <span style="font-size: 1.2em; color:#2d2d2d;line-height:35px;">
              매장 내 POP
            </span>
            <span style="font-size: 1.6em;font-weight:bold;color:#6e6e6e;line-height: 35px;">
              제작 / 출력 무료
            </span>
            <hr style="margin:15px 0px;border: 4px solid #2d2d2d;width:40%;">
            <span style="font-size: 1.1em; line-height:27px;color:#2d2d2d;">
              매장운영에 꼭 필요한 POP
            </span>
            <span style="font-size: 1.1em; line-height:27px;color:#2d2d2d;">
              세리 서비스를 통해 무료로 해결<br>
            </span>
            <div style="width:100%;display: flex;margin-top: 20px;align-items: flex-start;justify-content: center;">
              <img src="@/assets/mobile/main10-icon1.png" class="page-10-icon" alt="">
              <img src="@/assets/mobile/main10-icon2.png" class="page-10-icon" alt="">
              <img src="@/assets/mobile/main10-icon3.png" class="page-10-icon" alt="">
            </div>
          </div>
        </div>
        <div class="page-11 page">
          <img src="@/assets/mobile/main11.png" class="main01" alt="">
        </div>
        <div class="page-12 page">
          <img src="@/assets/mobile/main12.png" class="main01" alt="">
        </div>
        <div class="page-17 page">
          <img src="@/assets/mobile/main17.png" class="main01" alt="">
        </div>
        <div class="page-13 page">
          <div class="page-13-top">
            <div></div>
            <div class="page-13-list">
              <img src="@/assets/mobile/icon_markup.png" style="height:34px;" class="page-13-icon" alt="">
              <span style="text-align:left;">
                대한민국 부산광역시 동래구 온천천로 71, 6층
              </span>
            </div>
            <div class="page-13-list">
              <img src="@/assets/mobile/icon_mail.png" style="width:31px;" class="page-13-icon" alt="">
              <span style="text-align:left; ">
                <a href="mailto:manager@tonovation.com">cs@tonovation.com</a>
              </span>
            </div>
            <div class="page-13-list">
              <img src="@/assets/mobile/icon_phone.png" style="height:31px;margin:0px 4px;" class="page-13-icon" alt="">
              <span style="text-align:left; margin: 0px 20px 0px; 0px;">
                <a href="tel:1661-9068">1661-9068</a>
              </span>
            </div>
          </div>
          <div class="page-13-bot">
            <google-map id="map" ref="Map" :options="mapOptions">
              <google-map-marker
                  v-for="(infoWindow, index) in infoWindowsList"
                  :position="infoWindow.position"
                  :key="index"
                  @click="toggleInfoWindow(infoWindow)"
              />
              <google-map-infowindow
                  :position="infoWindowContext.position"
                  :show.sync="showInfo"
                  :options="{maxWidth: 300}"
                  @info-window-clicked="infoClicked"
              >
                <h4>{{infoWindowContext.title}}</h4>
                <p>{{infoWindowContext.description}}</p>
              </google-map-infowindow>
            </google-map>
          </div>
        </div>
        <div class="page-14 page">
          <div>
            <img src="@/assets/mobile/standard_qna.png" class="qna-icon" alt="">
          </div>
          <div style="width:100%;height:auto;margin:10px 0px;">
            <input type="text" class="input-text" v-model="qnaData.userName" placeholder="이름">
          </div>
          <div style="width:100%;height:auto;margin:10px 0px;">
            <input type="text" class="input-text" v-model="qnaData.userEmail" placeholder="이메일">
          </div>
          <div style="width:100%;height:auto;margin:10px 0px;">
            <input type="tel" class="input-text" v-model="qnaData.phone" placeholder="전화번호">
          </div>
          <div style="width:100%;height:auto;margin:10px 0px;">
            <textarea class="input-content" v-model="qnaData.userContents" placeholder="문의내용"/>
          </div>
          <div style="width:100%;height:auto;margin:10px 0px;text-align:right;">
            <button class="btn-question" style="width:100%;" @click="sendMail1(0)">문의하기</button>
          </div>
        </div>
        <div class="page-15 page">
          <div>
            <img src="@/assets/mobile/addFunc_icon.png" class="qna-icon" alt="">
          </div>
          <div style="width:100%;height:auto;margin:10px 0px;">
            <input type="text" class="input-text" v-model="orderData.userName" placeholder="이름">
          </div>
          <div style="width:100%;height:auto;margin:10px 0px;">
            <input type="text" class="input-text" v-model="orderData.userEmail" placeholder="이메일">
          </div>
          <div style="width:100%;height:auto;margin:10px 0px;">
            <input type="tel" class="input-text" v-model="orderData.phone" placeholder="전화번호">
          </div>
          <div style="width:100%;height:auto;margin:10px 0px;">
            <textarea class="input-content" v-model="orderData.userContents" placeholder="문의내용"/>
          </div>
          <div style="width:100%;height:auto;margin:10px 0px;text-align:right;">
            <button class="btn-question" style="width:100%;" @click="sendMail1(1)">요청하기</button>
          </div>
        </div>
        <div class="page-16 page">
          <div class="page-16-div" style="flex: 1;align-items: flex-end;padding:20px;">
            <span class="page-16-title">
              단 한번이라도 전단지를 경험해본 모든 업종
            </span>
          </div>
          <div class="page-16-div" style="flex: 1;padding:10px;justify-content: space-around;">
            <img src="@/assets/mobile/mart_icon.png" class="page-16-icon" alt="">
            <img src="@/assets/mobile/meat_icon.png" class="page-16-icon" alt="">
            <img src="@/assets/mobile/sidedish_icon.png" class="page-16-icon" alt="">
            <img src="@/assets/mobile/fruit_icon.png" class="page-16-icon" alt="">
          </div>
          <div class="page-16-div" style="flex: 2;position:relative;">
            <img src="@/assets/mobile/main16.png" class="main01" alt="">
          </div>
            <div class="page-16-content">
              <span style="font-size: 1.2em; color:#ffffff;line-height:35px;font-weight:100;">
                세리서비스
              </span>
              <span style="font-size: 1.6em;font-weight:bold;color:#ffffff;line-height: 35px;">
                이용하기
              </span>
              <hr style="margin:15px 0px;border: 4px solid #ffffff;width:40%;">
              <span style="font-size: 1.1em; line-height:27px;color:#ffffff;">
                무료체험과 동시에
              </span>
              <span style="font-size: 1.1em; line-height:27px;color:#ffffff;">
                3만원 무료충전<br>
              </span>
              <button class="page-2-btn" @click="openJoin">
                무료체험하기
              </button>
            </div>
        </div>
      </div>
    </div>
    <div class="bot-btn-div">
      <button class="bot-btn" @click="openJoinMobile">
        <span>무료체험</span><br>
        <span>3만원 무료충전</span>
      </button>
    </div>
    <modal name="promoModal" :width="300" :height="'auto'">
      <div class="modalMain" v-if="joinFlag === 0">
        <div class="modalHead">
          <img src="@/assets/logo.png" class="modalLogo" alt="">
          <h2>무료체험신청</h2>
          <span class="promo-content">
            무료체험에 이용할<br>아이디와 비밀번호를 설정해 주세요.
          </span>
        </div>
        <div class="modalBody">
          <div class="id-div">
            <label for="userId" class="id-label">
              아이디
            </label>
            <input type="text" name="userId" id="userId" class="input-id" v-model="userId">
          </div>
          <div class="id-div">
            <label for="userPw" class="id-label">
              비밀번호
            </label>
            <input type="password" name="userPw" id="userPw" class="input-id" v-model="userPw">
            <input type="password" name="chkUserPw" id="chkUserPw" class="input-id" v-model="chkUserPw" placeholder="비밀번호를 한번 더 입력하세요.">
          </div>
        </div>
        <div class="modalFoot">
          <button class="modalRegBtn" @click="joinSery">신&nbsp;청&nbsp;하&nbsp;기</button>
        </div>
      </div>
      <div class="modalBody" v-else>
        <div class="modalHead">
          <img src="@/assets/icon-party-cracker.png" alt="">
          <h2 style="margin: 0; font-size: 27px;color:#D32364;font-weight:bold;">
            30,000 충전완료 !
          </h2>
        </div>
        <div class="modalBody">
          <button class="btn-goSery" @click="goHandy">확인하러가기</button>
        </div>
        <div class="modalFoot">
          <h2>
            문의 1661-9068
          </h2>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { TastyBurgerButton } from 'vue-tasty-burgers'
import cities from '@/assets/cities.json'
import axios from 'axios'
import CryptoJS from 'crypto-js'
export default {
  components: {
    'tasty-burger-button': TastyBurgerButton
  },
  name: 'mobile',
  watch: {
    userId () {
      const regExp = /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]*$/
      if (regExp.test(this.userId)) {
        if (this.userId !== '') {
          this.userId = ''
          alert('한글은 사용할 수 없습니다.')
        } else {
          console.log('공백')
        }
      } else {
        return false
      }
    }
  },
  data () {
    return {
      smallViewFlag: 0,
      showInfo: false,
      menuFlag: 0,
      buttonType: 'vortex',
      isActive: false,
      size: 's',
      color: 'black',
      activeColor: 'black',
      type: 'spin',
      currentPage: 0,
      opts: {
        // 전체 세로 scroll
        start: 0,
        dir: 'v',
        duration: 100,
        loop: false,
        autoScrolling: false,
        scrollHorizontally: false,
        afterChange: (prev, next) => {
          this.currentPage = next
          console.log(next)
          this.sendGtag(next)
        }
      },
      mapOptions: {
        zoom: 16,
        minZoom: 3,
        center: {
          lat: 35.21289818910496,
          lng: 129.08055087877594
        },
        draggable: false,
        streetViewControl: false,
        scrollwheel: false,
        mapTypeControl: false
      },
      infoWindowContext: {
        position: {
          lat: 35.21289818910496,
          lng: 129.08055087877594
        },
        title: '토노베이션',
        description: '회사'
      },
      infoWindowsList: cities,
      qnaData: {
        userName: '',
        userEmail: '',
        phone: '',
        userContents: '',
        flag: 3
      },
      orderData: {
        userName: '',
        userEmail: '',
        phone: '',
        userContents: '',
        flag: 4
      },
      joinFlag: 0,
      userPw: '',
      chkUserPw: '',
      userId: ''
    }
  },
  mounted () {
    console.log('first')
  },
  methods: {
    onToggle (active) {
      console.log('11111', active, this.isActive)
      if (active) {
        this.menuFlag = 1
      } else {
        this.menuFlag = 0
      }
    },
    moveto (val, category) {
      this.currentPage = val
      if (this.menuFlag === 1) {
        document.getElementById('menuBtn').click()
      }
      this.$refs.main.$fullpage.moveTo(val, true, true)
      if (!this.$empty(category)) {
        this.sendGtag(val, category)
      } else {
        this.sendGtag(val)
      }
    },
    infoClicked (context) {
      console.log(context)
    },
    // inputClick () {
    //   var inputFields = [
    //     {
    //       inputId: '#nameInput'
    //     },
    //     {
    //       inputId: '#emailInput'
    //     },
    //     {
    //       inputId: '#homephoneInput'
    //     },
    //     {
    //       inputId: '#mobilephoneInput'
    //     },
    //     {
    //       inputId: '#addressInput'
    //     }
    //   ]
    // },
    sendMail1 (val) {
      var data = val === 0 ? this.qnaData : this.orderData
      if (this.$empty(data.userName) ||
      this.$empty(data.userEmail) ||
      this.$empty(data.phone) ||
      this.$empty(data.userContents)) {
        alert('내용을 확인해 주세요.')
      } else {
        var tmp1 = `${val === 0 ? '[세리일반문의] ' : '[추가기능요청] '} ${data.userName}`
        var tmp2 = `${data.userContents} \n 전화번호: ${data.phone}`
        data.name = tmp1
        data.userContents = tmp2
        this.$axios({
          // url: 'http://localhost:3333/sendTerymarket',
          url: 'https://sery.co.kr/sendEmail',
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
          },
          method: 'post',
          data: data
        })
          .then(response => {
            console.log(response)
            if (response.status === 200) {
              alert('문의가 접수되었습니다.')
              this.qnaData = {
                userName: '',
                userEmail: '',
                phone: '',
                userContents: '',
                flag: 3
              }
              this.orderData = {
                userName: '',
                userEmail: '',
                phone: '',
                userContents: '',
                flag: 4
              }
            }
          })
          .catch(error => {
            console.log('err:::', error)
            alert('입력된 정보를 확인해 주세요.')
          })
      }
    },
    goHandy () {
      var id = this.userId
      var pw = this.crypto(this.userPw)
      this.userId = ''
      this.userPw = ''
      this.chkUserPw = ''
      window.open(`https://sery.sery.co.kr/#/?id=${id}&pw=${pw}`)
      // window.open(`http://localhost:8080/#/?id=${id}&pw=${pw}`)
    },
    crypto (value) {
      return CryptoJS.AES.encrypt(value, 'handysecretkey').toString()
    },
    openJoinMobile () {
      if (this.menuFlag === 1) {
        document.getElementById('menuBtn').click()
      }
      this.joinFlag = 0
      this.$gtag.event(`M_홈페이지_NEW무료체험신청클릭`, {
        'event_category': 'MOBILE_기능'
      })
      this.$modal.show('promoModal')
    },
    openJoin () {
      if (this.menuFlag === 1) {
        document.getElementById('menuBtn').click()
      }
      this.joinFlag = 0
      this.$gtag.event(`M_홈페이지_무료체험신청클릭`, {
        'event_category': 'MOBILE_기능'
      })
      this.$modal.show('promoModal')
    },
    clickKakao () {
      console.log('123')
      document.getElementById('create-channel-chat-button').click()
    },
    async joinSery () {
      var result = localStorage.getItem('result')
      var LAMBDA_API = 'https://dzgneh35a3.execute-api.ap-northeast-2.amazonaws.com/prod'
      var objData = {
        storeSeq: '',
        storeId: this.userId,
        storePwd: this.userPw
      }
      if (this.userPw !== this.chkUserPw || (this.$empty(this.userPw) || this.$empty(this.chkUserPw))) {
        alert('패스워드가 일치하지 않습니다.')
      } else if (!this.$empty(objData.storeId)) {
        var chkDup = await chkDuplicateId()
        if (chkDup > 0) {
          alert('아이디가 중복되었습니다.')
        } else {
          this.$gtag.event(`M_홈페이지_무료체험신청완료`, {
            'event_category': 'MOBILE_기능'
          })
          var func2 = ''
          var func1 = await getMaxStoreSeq()
          console.log('1st:::', func1)
          if (func1 === 'success1') {
            func2 = await insertJoinsery()
            if (func2 === 'success2') {
              this.joinFlag = 1
            }
          }
        }
      }
      function chkDuplicateId () {
        return new Promise((resolve, reject) => {
          axios({
            method: 'get',
            url: LAMBDA_API + '/chkDuplicateId',
            params: {
              id: objData.storeId
            }
          })
            .then((response) => {
              resolve(response.data[0].cnt)
            })
        })
      }
      function getMaxStoreSeq () {
        return new Promise((resolve, reject) => {
          axios({
            method: 'get',
            url: LAMBDA_API + '/getMaxStoreSeq',
            params: {
              store_seq: '0001234567'
            }
          })
            .then((response) => {
              console.log('1:::', response)
              objData.storeSeq = response.data
              resolve('success1')
            })
        })
      }
      function insertJoinsery () {
        return new Promise((resolve, reject) => {
          var formData = new FormData()
          var type = 0
          if (result.type !== undefined && result.type.trim() !== '') {
            if (result.type.trim() === '마트') {
              type = 0
            } else if (result.type.trim() === '외식') {
              type = 1
            } else if (result.type.trim() === '기타') {
              type = 2
            } else if (result.type.trim() === '정육') {
              type = 3
            }
            var storeManager = ''
            if (result.type.trim() === '정창모') {
              storeManager = 'si_00000046'
            }
            if (result.type.trim() === '좋은슈퍼') {
              storeManager = 'si_00000047'
            }

            formData.append('storeType', type)
            formData.append('category', result.type.trim())
            formData.append('storeManager', storeManager)
          } else {
            formData.append('storeType', 0)
            formData.append('category', '마트')
          }
          formData.append('storeSeq', objData.storeSeq)
          formData.append('storeName', '신규가입매장')
          formData.append('bsrn', '1231212345')
          formData.append('storeAddr', '부산 동래구 온천천로 71, 6층')
          formData.append('lat', 35.21289818910496)
          formData.append('lng', 129.08055087877594)
          formData.append('detailAddr', '')
          formData.append('storeTel', '0001234567')
          formData.append('storeBirthday', '19700101')
          formData.append('storePay', 20)
          formData.append('storePartner', 1)
          formData.append('admin_agency', 1)
          formData.append('startTime', '0000')
          formData.append('endTime', '0000')
          formData.append('storeBreak', '연중무휴')
          formData.append('storePage', '0000')
          formData.append('minCharge', 300000)
          formData.append('DELIVERY_FLAG', 0)
          formData.append('PUBLIC_FLAG', 1)
          formData.append('pwdValue', '')
          formData.append('memo', '')
          formData.append('storeCeo', '신규가입고객님')
          formData.append('storePhone', null)
          formData.append('storeEmail', 'new@new.com')
          formData.append('storeId', objData.storeId)
          formData.append('storePwd', objData.storePwd)
          formData.append('business', '소매')
          axios({
            method: 'post',
            url: LAMBDA_API + '/insertSeryStore',
            data: formData
          })
            .then((response) => {
              console.log('2:::', response)
              if (response.data === 'success') {
                resolve('success2')
              }
            })
        })
      }
    },
    sendGtag (val, cagetory) {
      const vm = this
      if (this.$empty(cagetory)) {
        cagetory = 'none'
        switch (val) {
          case 0:
            mountPage('M_홈페이지_HOME1')
            break
          case 1:
            mountPage('M_홈페이지_HOME2')
            break
          case 2:
            mountPage('M_홈페이지_사용후기1')
            break
          case 3:
            mountPage('M_홈페이지_사용후기2')
            break
          case 4:
            mountPage('M_홈페이지_사용후기3')
            break
          case 5:
            mountPage('M_홈페이지_사용후기4')
            break
          case 6:
            mountPage('M_홈페이지_사용후기5')
            break
          case 7:
            mountPage('M_홈페이지_사용후기6')
            break
          case 8:
            mountPage('M_홈페이지_인공지능세리_전단지')
            break
          case 9:
            mountPage('M_홈페이지_인공지능세리_POP')
            break
          case 10:
            mountPage('M_홈페이지_인공지능세리_테리')
            break
          case 11:
            mountPage('M_홈페이지_인공지능세리_문자3.0')
            break
          case 12:
            mountPage('M_홈페이지_서비스문의1')
            break
          case 13:
            mountPage('M_홈페이지_서비스문의2')
            break
          case 14:
            mountPage('M_홈페이지_서비스문의3')
            break
          case 15:
            mountPage('M_홈페이지_추가기능요청')
            break
          case 16:
            mountPage('M_홈페이지_이벤트_카테고리')
            break
          case 17:
            mountPage('M_홈페이지_카카오')
            break
        }
      } else {
        switch (val) {
          case 0:
            mountPage('M_홈페이지_HOME_카테고리')
            break
          case 2:
            mountPage('M_홈페이지_사용후기_카테고리')
            break
          case 8:
            mountPage('M_홈페이지_인공지능세리_카테고리')
            break
          case 12:
            mountPage('M_홈페이지_서비스문의_카테고리')
            break
          case 16:
            mountPage('M_홈페이지_이벤트_카테고리')
            break
        }
      }
      function mountPage (pageName) {
        vm.$gtag.event(`${pageName}`, {
          'event_category': 'MOBILE_접속'
        })
      }
    }
  }
}
</script>
<style scoped>
@import url('./css/mobile.css');
/* @import url('./css/main.css'); */
</style>



// WEBPACK FOOTER //
// src/components/mobile.vue